<template>
	<v-container>
		<v-dialog v-model="showDialog" max-width="90%">
			<v-skeleton-loader v-if="loading" type="article, actions"></v-skeleton-loader>
			<v-card v-if="!loading" class="pt-1 elevation-0">
				<v-card-title>
					<v-panel>
						<span style="font-size: 20px;">
							{{ $t('wkt.admin.license.purchase-license-item-window.title') }}
						</span>
					</v-panel>
				</v-card-title>
				<v-card-text>
					<v-container class="pt-0 px-6">
						<v-row style="margin-top: 10px;">
							<!--<v-col cols="12" class="px-0">
								<h2 class="black--text">{{ $t('wkt.admin.license.purchase-license-item-window.title') }}</h2>
							</v-col>-->
							<v-col cols="12" class="pa-0">
								<span style="font-size: 14px;" class="black--text">
									{{ $t('wkt.admin.license.purchase-license-item-window.subtitle') }}
								</span>
							</v-col>
							<v-col cols="12" class="px-0 mt-2 pb-0">						
								<PurchaseLicenseItem 
									:company="company" 
									:licensingInfo="licensingInfo" 
									:licenseType="selectedType" 
									:licensePlan="selectedPlan" 
									:currentEmployees="currentEmployees"
									:currentStorage="currentStorage"
									:currentSignatures="currentSignatures"
									:voucher="currentVoucher"
									:itemType="itemType"
									@employees-changed="updateAdditionalEmployees($event)" 
									@storage-changed="updateAdditionalStorage($event)" 
									@signatures-changed="updateAdditionalSignatures($event)"
									@add-voucher="addVoucher($event)" />
							</v-col>					
						</v-row>					
						<v-row class="pt-2 pb-4 d-flex justify-space-between align-start">
							<v-col v-if="itemType === constants.ITEM_EMPLOYEES || itemType === constants.ITEM_STORAGE" cols="6" class="mt-1 pa-0 pl-6 d-flex align-center">
								<span style="font-size: 16px;">{{ nextRenewal }}</span>
							</v-col>
							<v-col :cols="itemType === constants.ITEM_SIGNATURES ? '12' : '6'" class="mt-1 pa-0 d-flex flex-column">
								<div class="pr-6 d-flex justify-end">
									<span style="font-size: 16px;" class="mr-2">
										{{ $t('wkt.admin.license.upgrade-account-window.step-3.gross_amount') }}
									</span>
									<span style="width: 100px; font-size: 16px; text-align: right;">{{ amount }}</span>
								</div>
								<div class="pr-6 d-flex justify-end">
									<span style="font-size: 16px; color: #A0A0A0;" class="mr-2">
										{{ $t('wkt.admin.license.upgrade-account-window.step-3.taxes') }}
									</span>
									<span style="width: 100px; font-size: 16px; color: #A0A0A0; text-align: right;">{{ taxes }}</span>
								</div>
								<div v-if="currentVoucher" class="pr-6 d-flex justify-end">
									<span style="font-size: 16px;" class="mr-2 green--text">
										{{ $t('wkt.admin.license.upgrade-account-window.step-3.discount') }}
									</span>
									<span style="width: 100px; font-size: 16px; text-align: right;" class="green--text">{{ discount }}</span>
								</div>
								<div class="pr-6 d-flex justify-end">
									<span style="font-size: 16px;" class="mr-2 black--text font-weight-bold">
										{{ $t('wkt.admin.license.upgrade-account-window.step-3.total_amount') }}
									</span>
									<span style="width: 100px; font-size: 16px; text-align: right;" class="black--text font-weight-bold">{{ total }}</span>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="#185EA9" text @click="openLicenseRates()" style="font-size: 0.9em; font-weight: 400;">
						<v-icon small color="#185EA9" class="mr-2">open_in_new</v-icon>
						<span class="text-decoration-underline">{{ $t('wkt.admin.license.upgrade-account-window.step-1.more_info').toUpperCase() }}</span>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="#185EA9" text @click="processPurchaseOrder()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.continue').toUpperCase() }}</v-btn>
					<v-btn text @click="showDialog = false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar
		v-model="showAlert"
		:timeout="alertTimeout"
		:color="alertColor">
				<span style="color: #ffffff;">{{alertText}}</span>
				<v-btn text @click="showAlert=false">
				<span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
				</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import PurchaseUtils from './PurchaseUtils.js';
import api from '../../../../api/worktime.js';
import gwt from '../../../../api/gwt.js';
import PurchaseLicenseItem from './PurchaseLicenseItem';

export default {
    name: 'PurchaseLicenseItemDialog',
    mixins: [BaseModule, PurchaseUtils],
	components: {
		PurchaseLicenseItem
	},
    data () {
		return {
			loading: false,
			company: null,
			itemType: null,
			licensingInfo: null,
			selectedPlan: null,
			selectedType: null,
			currentEmployees: 0,
			currentStorage: 0, 
			currentSignatures: 0,
			additionalAmount: 0,
			currentVoucher: null,
			renewDate: null,
			upgradePrice: 0.0,
			periodPrice: 0.0,
			periodTax: 0.0,
			showAlert: false,
			alertColor: 'error',
			alertText: '',
			alertTimeout: 3000,
			showDialog: false,
		}
    },
	computed: {
		nextRenewal() {
			if (!this.company) {
				return '???';
			}

			let text = this.$t('wkt.admin.license.purchase-item-window.next-expiration');
			text += `: ${this.formatOnlyDate(this.company.licensePlanExpires)} (+${this.upgradePrice.toFixed(2)}€)`;
			
			return text;
		},		
		amount() {
			let amount = Math.round((this.periodPrice * 100) * (1 + Number.EPSILON)) / 100;
			return `${amount.toFixed(2)}€`;
		},
		taxes() {
			let taxes = Math.round((this.periodTax * 100) * (1 + Number.EPSILON)) / 100;
			return `${taxes.toFixed(2)}€`;
		},
		discount() {
			const discount = Math.round(this.currentVoucher.discountPercent * 10000) / 100;
			return `-${discount}%`;
		},
		total() {
			let amount = Math.round((this.periodPrice * 100) * (1 + Number.EPSILON)) / 100;
			let taxes = Math.round((this.periodTax * 100) * (1 + Number.EPSILON)) / 100;
			let total = amount + taxes;
			
			if (this.currentVoucher) {
				total = total * (1 - this.currentVoucher.discountPercent);			
			}
			
			total = Math.round((total * 100) * (1 + Number.EPSILON)) / 100;

			return `${total.toFixed(2)}€`;
		}
	},
    methods: {
		onReveal(action) {
			this.company = action.company;
			this.itemType = action.itemType;
			
			this.currentVoucher = null;

			this.open();
		},
		open() {
			this.refreshLicensingInfo();
				
			this.showDialog = true;
		},
		close() {				
			this.showDialog = false;
		},		
		refreshLicensingInfo() {
			this.loading = true;

			api.getSKULicensingInfo(
				data => {
					this.loading = false;
					this.licensingInfo = data;

					this.selectedType = this.company.licenseType;
					this.selectedPlan = this.company.licensePlan;

					if (this.itemType === this.constants.ITEM_EMPLOYEES) {						
						this.currentEmployees = this.company.currentSeatLimit;
					}

					if (this.itemType === this.constants.ITEM_STORAGE) {						
						this.currentStorage = this.company.currentStorageLimit;
					}

					if (this.itemType === this.constants.ITEM_SIGNATURES) {						
						this.currentSignatures = this.company.remainingSignatures;
					}
				},
				error => {
					this.loading = false;
					this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
				}
			);
		},
		openLicenseRates() {			
			window.open('https://tweem.com/tarifas-tweem', '_blank');
		},
		updateAdditionalEmployees(num) {
			this.additionalAmount = num;
			console.log(`**** additionalEmployees: ${this.additionalAmount}`);
			this.calculateLicenseAmounts();
		},
		updateAdditionalStorage(num) {
			this.additionalAmount = num;
			console.log(`**** additionalStorage: ${this.additionalAmount}`);
			this.calculateLicenseAmounts();
		},
		updateAdditionalSignatures(num) {
			this.additionalAmount = num;
			console.log(`**** additionalSignatures: ${this.additionalAmount}`);
			this.calculateStockAmounts();
		},
		calculateLicenseAmounts() {
			const itemType = this.itemType === this.constants.ITEM_EMPLOYEES ? this.constants.ACTIVE_EMPLOYEES : this.constants.STORAGE_MB;

			const license = this.findLicenseSKU(this.licensingInfo, itemType, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			this.upgradePrice = license.price * this.additionalAmount;

			const now = new Date();
			const end = new Date(this.company.licensePlanExpires);
			let start = new Date(end.getTime());

			if (this.company.licensePlan == this.constants.LICENSE_PLAN_MONTHLY) {
				start.setMonth(start.getMonth() - 1);
			} else {
				start.setMonth(start.getMonth() - 12);
			}

			//this.renewDate = start;

			/*const expiresMinusNow = (end.getTime() - now.getTime());
			const expiresMinusStart = (end.getTime() - start.getTime());
			const periodPercent = expiresMinusNow / expiresMinusStart;*/
			const periodPercent = (end.getTime() - now.getTime()) / (end.getTime() - start.getTime());

			this.periodPrice = this.upgradePrice * periodPercent;

			this.periodTax = this.periodPrice * license.taxPercent;
		},
		calculateStockAmounts() {
			const stock = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			this.periodPrice = stock.price * this.additionalAmount;

			this.periodTax = this.periodPrice * stock.taxPercent;
		},
		addVoucher(voucher) {
			console.log(`**** voucher added: ${voucher.code}`);
			this.currentVoucher = voucher;
			this.$emit('voucher-used', voucher);
		},
		getDescription() {
			let description = '???';

			switch (this.itemType) {
				case this.constants.ITEM_EMPLOYEES:
					description = this.$t('wkt.admin.license.purchase-item-window.purchase_employees');
					break;
				case this.constants.ITEM_STORAGE:
					description = this.$t('wkt.admin.license.purchase-item-window.update-plan.purchase_storage');
					break;
				case this.constants.ITEM_SIGNATURES:
					description = this.$t('wkt.admin.license.purchase-item-window.update-plan.purchase_signatures');
					break;				
			}

			return description;
		},
		getItemType() {
			let itemType = -1;

			switch (this.itemType) {
				case this.constants.ITEM_EMPLOYEES:
					itemType = this.constants.ACTIVE_EMPLOYEES;
					break;
				case this.constants.ITEM_STORAGE:
					itemType = this.constants.STORAGE_MB;
					break;
				case this.constants.ITEM_SIGNATURES:
					itemType = this.constants.SMS_SIGNATURE;
					break;				
			}

			return itemType;
		},
		processPurchaseOrder() {
			const po = {
				companyId: this.company.id,
				licenseType: this.selectedType,
				licensePlan: this.selectedPlan,
				//description: this.getDescription(),
				orderType: this.constants.ORDER_TYPE_ITEM_PURCHASE			
			};

			if (this.currentVoucher) {
				po.voucherCode = this.currentVoucher.code;
			}

			if (this.itemType === this.constants.ITEM_EMPLOYEES || this.itemType === this.constants.ITEM_STORAGE) {
				po.licenses = this.buildPurchaseOrderLicenses();
			} else {
				po.stock = this.buildPurchaseOrderStock();
			}

			this.loading = true;

			api.createPurchaseOrder(po, 
				data => {
					this.loading = false;
					this.doPayment(data);
				},
				error => {
					this.loading = false;
					this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
				}
			);
		},		
		buildPurchaseOrderLicenses() {
			let licenses = [];

			const itemType = this.itemType === this.constants.ITEM_EMPLOYEES ? this.constants.ACTIVE_EMPLOYEES : this.constants.STORAGE_MB;

			// Licencias
			const sku = this.findLicenseSKU(this.licensingInfo, itemType, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			sku.itemType = this.getItemType();
			
			console.log(`**** sku ${itemType === 0 ? 'EMPLOYEES' : 'STORAGE'} EXTENSION: ${JSON.stringify(sku)}`);
				
			licenses.push(this.createLicenseFromSKU(sku, this.company.id, this.additionalAmount));

			return licenses;
		},
		buildPurchaseOrderStock() {
			let stock = [];

			// Firmas
			let sku = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_EXTENSION);

			sku.itemType = this.getItemType();
			
			console.log(`**** sku SIGNATURES EXTENSION: ${JSON.stringify(sku)}`);
				
			stock.push(this.createStockFromSKU(sku, this.company.id, this.additionalAmount));

			return stock;
		},
		doPayment(request) {
			// Se ha procesado directamente
			if (request.totalAmount === 0) {
				const payload = { 
					message: 'ok'
				};

				gwt.fireEvent('PaymentMessageEvent', JSON.stringify(payload));

				//onPurchaseCompleted(); --> LicenseQuotaUpdatedEvent.fire(this);
				//getView().onPurchaseCompleted(true);
			} else {
				const payload = { 
					title: 'wkt.admin.license.payment.confirmation.title', 
					url: `../external/payment/redirect/${request.id}`, 
					showIcon: false 
				};

				gwt.fireEvent('ShowExternalContentEvent', JSON.stringify(payload));

				//ShowExternalContentEvent.fire(this, "wkt.admin.license.payment.confirmation.title",
				//ApplicationConstants.SERVICE_URL + "../external/payment/redirect/" + request.id, false);
			}
		},
		doShowAlert(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
    },
}
</script>